import * as React from 'react';

import { useInviteRostersByProgramIds } from 'bundles/enterprise-admin-learners/hooks/useInviteRostersByProgramIds';

/**
 * Narrows `programIds` down to those with an active roster under `contractId` — lets the
 * manual group picker hide contract-ineligible groups up front instead of letting an admin
 * pick one and only then discover it's incompatible (see IncompatibleContractGroupModal).
 * Returns `undefined` when there's no contract to scope by (single-contract orgs) or the
 * query hasn't resolved yet — callers should treat that as "don't filter".
 */
export const useContractEligibleGroupIds = (programIds: string[], contractId: string | undefined) => {
  const { rosterIdByProgramId, loading } = useInviteRostersByProgramIds(programIds, contractId);

  const eligibleGroupIds = React.useMemo(
    () => (rosterIdByProgramId ? new Set(rosterIdByProgramId.keys()) : undefined),
    [rosterIdByProgramId]
  );

  return { eligibleGroupIds, loading };
};

export default useContractEligibleGroupIds;
